const defaultTheme = {
  primary: `#555555`,
  secondary: `#000000`,
  tertiary: `#aaaaaa`,
  quaternary: `#ffffff`,
}

export default defaultTheme
